"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var client_1 = require("@apollo/client");
var AcPdfDateStampInputs_1 = require("../dateStampMenu/AcPdfDateStampInputs");
var AcPdfDateStampSaveButtons_1 = require("../dateStampMenu/AcPdfDateStampSaveButtons");
var AcStampButton_1 = require("../stamps/AcStampButton");
var Stamp_1 = require("../stamps/Stamp");
var AcPdfEditorSideMenu_1 = require("../AcPdfEditorSideMenu");
var AcPageTitle_1 = require("../../layout/AcPageTitle");
exports.QUERY = client_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query AcPdfDateStampMenuQuery($id: Int!) {\n    viewer {\n      id\n      faxStamp(id: $id) {\n        id\n        faxStampId\n        type\n        companyContractFaxId\n        topPartName\n        middlePartFormat\n        bottomPartName\n      }\n    }\n  }\n"], ["\n  query AcPdfDateStampMenuQuery($id: Int!) {\n    viewer {\n      id\n      faxStamp(id: $id) {\n        id\n        faxStampId\n        type\n        companyContractFaxId\n        topPartName\n        middlePartFormat\n        bottomPartName\n      }\n    }\n  }\n"])));
exports.updateFaxStampMutation = client_1.gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  mutation UpdateFaxStampMutation($input: UpdateFaxStampInput!) {\n    updateFaxStamp(input: $input) {\n      faxStamp {\n        id\n        faxStampId\n        type\n        companyContractFaxId\n        topPartName\n        middlePartFormat\n        bottomPartName\n      }\n    }\n  }\n"], ["\n  mutation UpdateFaxStampMutation($input: UpdateFaxStampInput!) {\n    updateFaxStamp(input: $input) {\n      faxStamp {\n        id\n        faxStampId\n        type\n        companyContractFaxId\n        topPartName\n        middlePartFormat\n        bottomPartName\n      }\n    }\n  }\n"])));
exports.AcPdfDateStampMenu = function (_a) {
    var _b = _a.width, width = _b === void 0 ? '100%' : _b, height = _a.height;
    var setActiveMenu = react_1.useContext(AcPdfEditorSideMenu_1.AcPdfEditorSideMenuContext).setActiveMenu;
    var _c = client_1.useQuery(exports.QUERY, { variables: { id: -100 } }), loading = _c.loading, data = _c.data, error = _c.error;
    var _d = client_1.useMutation(exports.updateFaxStampMutation), updateFaxStamp = _d[0], loadingUpdate = _d[1].loading;
    var _e = react_1.useState(''), companyName = _e[0], setCompanyName = _e[1];
    var _f = react_1.useState('YY.MM.DD'), dateFormat = _f[0], setDateFormat = _f[1];
    var _g = react_1.useState(''), userName = _g[0], setUserName = _g[1];
    var dateStamp = Stamp_1.Stamp.dateStamp({ companyName: companyName, dateFormat: dateFormat, userName: userName });
    react_1.useEffect(function () {
        var _a;
        var faxStamp = (_a = data === null || data === void 0 ? void 0 : data.viewer) === null || _a === void 0 ? void 0 : _a.faxStamp;
        if (faxStamp) {
            setCompanyName(faxStamp.topPartName);
            setUserName(faxStamp.bottomPartName);
        }
    }, [JSON.stringify(data)]);
    var onClickSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var faxStamp, input;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    faxStamp = (_a = data === null || data === void 0 ? void 0 : data.viewer) === null || _a === void 0 ? void 0 : _a.faxStamp;
                    input = {
                        id: -100,
                        faxStampId: -100,
                        companyContractFaxId: faxStamp === null || faxStamp === void 0 ? void 0 : faxStamp.companyContractFaxId,
                        topPartName: companyName,
                        middlePartFormat: dateFormat,
                        bottomPartName: userName,
                    };
                    return [4 /*yield*/, updateFaxStamp({
                            variables: { input: input },
                        })];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(AcPageTitle_1.AcPageTitle, null,
            react_1.default.createElement("span", { className: "text-primary" },
                react_1.default.createElement("i", { className: "far fa-cog fs-22 fa-fw mr-1" }),
                react_1.default.createElement("span", { className: "fs-16 font-weight-bold" }, "\u30C7\u30FC\u30BF\u5370\uFF08\u65E5\u4ED8\u5370\uFF09\u306E\u8A2D\u5B9A"))),
        react_1.default.createElement("div", { className: "d-flex justify-content-center" },
            react_1.default.createElement(AcStampButton_1.AcStampButton, { stamp: dateStamp, width: 220, height: 220, preview: true })),
        react_1.default.createElement("div", { className: "text-left mb-7" },
            react_1.default.createElement(AcPdfDateStampInputs_1.AcPdfDateStampInputs, { setCompanyName: setCompanyName, companyName: companyName, setDateFormat: setDateFormat, dateFormat: dateFormat, setUserName: setUserName, userName: userName })),
        react_1.default.createElement(AcPdfDateStampSaveButtons_1.AcPdfDateStampSaveButtons, { onClickSave: onClickSave })));
};
exports.AcPdfDateStampMenu.displayName = 'AcPdfDateStampMenu';
var templateObject_1, templateObject_2;
//# sourceMappingURL=AcPdfDateStampMenu.js.map